import { useEffect, useState } from "react";

export default function ClientesView() {
  const [clientes, setClientes] = useState([]);
  const [clienteExpandidoId, setClienteExpandidoId] = useState(null);
  const [busqueda, setBusqueda] = useState("");

  useEffect(() => {
    const cargarClientes = async () => {
      try {
        const res = await fetch("http://localhost:5000/api/clientes");
        if (!res.ok) throw new Error(`Error HTTP: ${res.status}`);
        const data = await res.json();
        setClientes(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("❌ Error cargando clientes:", err);
      }
    };

    cargarClientes();
  }, []);

  const toggleDetalles = (id) => {
    setClienteExpandidoId(prev => (prev === id ? null : id));
  };

  //  Filtrado dinámico por ID, nombre y teléfono
  const clientesFiltrados = clientes.filter(c => {
    const coincideID = c.id?.toString().includes(busqueda);
    const coincideNombre = c.nombre?.toLowerCase().includes(busqueda.toLowerCase());
    const coincideTelefono = c.telefono?.toString().includes(busqueda);
    return coincideID || coincideNombre || coincideTelefono;
  });

  return (
    <div>
      {/* <h2 className="text-white mb-3">👥 Clientes registrados</h2> */}
      <h2 className="text-white mb-3">
  <i className="fas fa-users text-white me-2"></i>
  Clientes registrados
</h2>


      {/*  Buscador */}
      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Buscar por ID, nombre o teléfono"
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />
      </div>

      <ul className="list-group">
        {clientesFiltrados.length > 0 ? (
          clientesFiltrados.map(c => (
            <li
              key={c.id}
              className="list-group-item bg-dark"
              style={{ borderRadius: "10px", marginBottom: "10px" }}
            >
              {/*  Encabezado del cliente */}
              <div className="d-flex justify-content-between align-items-center">
                <div>
                <i className="bi bi-person-circle fs-4 me-2" style={{ color: 'white' }}></i>

                  <strong className="text-white ">{c.nombre}</strong>
                  <span className="text-white ms-2">({c.telefono})</span>
                </div>

                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => toggleDetalles(c.id)}
                >
                  {clienteExpandidoId === c.id ? "Ocultar detalles" : "Ver detalles"}
                </button>
              </div>

              {/* 🔽 Detalles colapsables */}
              {clienteExpandidoId === c.id && (
                <div className="card bg-dark text-white mt-3 border border-danger">
                  <div className="card-body">
                    <h5>Cliente ID: {c.id}</h5>
                    <p><strong>Nombre:</strong> {c.nombre}</p>
                    <p><strong>Teléfono:</strong> {c.telefono}</p>
                    <p><strong>UUID:</strong> {c.uuid}</p>
                  </div>
                </div>
              )}
            </li>
          ))
        ) : (
          <li className="list-group-item text-muted">
            No hay clientes registrados
          </li>
        )}
      </ul>
    </div>
  );
}
